/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	RecruiterBookingAttendancePathParams,
	RecruiterBookingAttendanceRequest,
	RecruiterBookingAttendanceResponse,
} from '../types/RecruiterBookingAttendance'

/**
 * PUT /interview-scheduling/bookings/:bookingId/attendance
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterBookingController.php RecruiterBookingController::attendance
 */
export async function recruiterBookingAttendance(
	bookingId: RecruiterBookingAttendancePathParams['bookingId'],
	data: RecruiterBookingAttendanceRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<RecruiterBookingAttendanceResponse>> {
	return axiosInstance.put(`/interview-scheduling/bookings/${bookingId}/attendance`, data, config)
}
